const routes = {
  home: '/',
  signin: '/signin',
  query: '/query',
  update: '/update',
  updateConfig: '/config'
}

export default routes
